import mailboxAxios from "../utils/mailboxAxios";

export const notificationsApi = {
  getAll: (params = {}) => mailboxAxios.get("/notifications", { params }),
  getUnreadCount: () => mailboxAxios.get("/notifications/unread-count"),
  markRead: (id) => mailboxAxios.post(`/notifications/${id}/read`),
  markAllRead: () => mailboxAxios.post("/notifications/read-all"),
  runChecks: () => mailboxAxios.post("/notifications/run-checks"),
};